"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeysOf = void 0;
const getKeysOf = (dict) => {
    return Object.keys(dict);
};
exports.getKeysOf = getKeysOf;
